import AxiosControl from '../components/axios/AxiosControl'
import { getUnreadCount } from './authActions'
const Axios = AxiosControl()

export const getMessages = (params) => async (dispatch) => {
    dispatch({ type: 'MESSAGES_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/messages', {
            params,
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'MESSAGES_SUCCESS', payload: data.messages })
        }
    } catch (error) {
        dispatch({ type: 'MESSAGES_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getNotifications = () => async (dispatch) => {
    dispatch({ type: 'NOTIFICATIONS_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/messages', {
            params: { box: 'inbox' },
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'NOTIFICATIONS_SUCCESS', payload: data.messages })
        }
    } catch (error) {
        dispatch({ type: 'NOTIFICATIONS_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getNoticeboard = () => async (dispatch) => {
    dispatch({ type: 'NOTICEBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/messages', {
            params: { type: 'noticeboard' },
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'NOTICEBOARD_SUCCESS', payload: data.messages })
        }
    } catch (error) {
        dispatch({ type: 'NOTICEBOARD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getSentMessages = () => async (dispatch) => {
    dispatch({ type: 'SENT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/messages', {
            params: { box: 'sent' },
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SENT_SUCCESS', payload: data.messages })
        }
    } catch (error) {
        dispatch({ type: 'SENT_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getThread = (threadId) => async (dispatch) => {
    dispatch({ type: 'THREAD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/messages/thread/' + threadId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'THREAD_SUCCESS', payload: data.messages })
        }
    } catch (error) {
        dispatch({ type: 'THREAD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const resetThread = () => (dispatch) => {
    dispatch({ type: 'THREAD_RESET' })
}

export const markNotificationRead = (id) => async (dispatch) => {
    try {
        await Axios.put('/api/teacher/messages/' + id + '/read', {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        dispatch({ type: 'MARK_READ', payload: id })
        dispatch(getUnreadCount())
    } catch (error) {
        // silent
    }
}

export const markAllNotificationsRead = () => async (dispatch) => {
    try {
        await Axios.put('/api/teacher/messages/read-all', {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        dispatch({ type: 'MARK_ALL_READ' })
        dispatch(getUnreadCount())
    } catch (error) {
        // silent
    }
}

export const sendMessage = (message) => async (dispatch) => {
    dispatch({ type: 'MESSAGE_SENDING' })
    try {
        const { data, status } = await Axios.post('/api/teacher/messages', message, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'MESSAGE_SEND_SUCCESS', payload: data.message || 'Mensaje enviado' })
            return data.message || true
        }
        return false
    } catch (error) {
        dispatch({ type: 'MESSAGE_SEND_ERROR', payload: error.response?.data?.message || error.message })
        return false
    }
}

export const resetMessage = () => (dispatch) => {
    dispatch({ type: 'MESSAGE_SEND_RESET' })
}

export const deleteMessage = (id) => async (dispatch) => {
    try {
        await Axios.delete('/api/teacher/messages/' + id, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        dispatch({ type: 'MESSAGE_DELETED', payload: id })
    } catch (error) {
        // silent
    }
}
